import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { newportConfig } from "./data";

export default function NewportRIPage() {
  return <CityPageTemplate config={newportConfig} />;
}